import ButtonDropdown from '@rio-cloud/rio-uikit/ButtonDropdown';
import DateTimeOrNoData from 'components/content/DateTimeOrNoData';
import NoData from 'components/content/NoData';
import { SystemAdminDialogTypes, SystemAdminFormTypes } from 'helper/types';
import { useDispatch, useSelector } from 'react-redux';
import {
    ActiveSidebar,
    getSelectedFleet,
    setActiveSidebar,
    setSelectedFleet,
    setSystemAdminOpenDialog,
} from 'store/slices/settingsPageSlice';
import { setFormFleetName, setSystemFleetsFormType } from 'store/slices/systemFleet';

import Can from '../../../components/auth/Can';

import type { SystemFleet } from 'API';

import './_styles.scss';

interface SystemFleetsRowProps {
    fleet: SystemFleet;
}

const SystemFleetsRow = ({ fleet }: SystemFleetsRowProps) => {
    const dispatch = useDispatch();
    const selectedFleet = useSelector(getSelectedFleet);
    const isActive = selectedFleet?.id === fleet.id;

    const handleRowClick = () => {
        dispatch(setSelectedFleet(fleet));
        dispatch(setActiveSidebar(ActiveSidebar.FLEETS));
    };

    const openEditFleetDialog = () => {
        dispatch(setSelectedFleet(fleet));
        dispatch(setFormFleetName(fleet.name));
        dispatch(setSystemAdminOpenDialog(SystemAdminDialogTypes.FLEET_DIALOG));
        dispatch(setSystemFleetsFormType(SystemAdminFormTypes.EDIT_FORM));
    };

    const dropdownItems = [
        {
            value: (
                <span className='SystemFleetsRow__dropdownItems'>
                    <span className='rioglyph rioglyph-pencil SystemFleetsRow__dropdownItemIcons' />
                    <p className='SystemFleetsRow__dropdownItemIcons'>Edit</p>
                </span>
            ),
            onSelect: openEditFleetDialog,
        },
    ];

    return (
        <tr
            id={fleet.id}
            data-testid='system-fleet-row'
            className={`cursor-pointer align-items-center ${isActive && 'active'}`}
            onClick={handleRowClick}
        >
            <td className='SystemFleetsRow__column' data-testid='system-fleet-row-info-name'>
                {fleet.name}
            </td>
            <td className='SystemFleetsRow__column' data-testid='system-fleet-row-info-vehicles'>
                {fleet.numberOfVehicles}
            </td>
            <td className='SystemFleetsRow__column' data-testid='system-fleet-row-info-teams'>
                {fleet.teams?.length ? (
                    fleet.teams
                        .map(role => role.name)
                        .join(', ')
                        .toString()
                ) : (
                    <NoData className='text-14' />
                )}
            </td>
            <td className='SystemFleetsRow__column' data-testid='system-fleet-row-info-createdAt'>
                <DateTimeOrNoData value={fleet.createdAt} />
            </td>
            <td
                data-testid='system-fleet-row-dropdown-icon'
                className='SystemFleetsRow__column--button'
                onClick={e => e.stopPropagation()}
            >
                <Can type='fleets' action='edit'>
                    <ButtonDropdown
                        title={<span className='rioglyph rioglyph-option-vertical SystemFleetsRow__dropdown' />}
                        items={dropdownItems}
                        bsStyle='muted'
                        iconOnly
                        dropup
                        noCaret
                        className='SystemFleetsRow__dropdownButton'
                    />
                </Can>
            </td>
        </tr>
    );
};

export default SystemFleetsRow;
